<template>
    <div class="bk-itm">
        <article class="productTile itemCategoryProduct" v-if="viewMode == 'vertical' && initialized">
            <bkAddToWishlist :variation-id="item.variation.id"></bkAddToWishlist>
            <div class="picture produkt_picture">
                <add-to-basket 
                    class="add-to-basket"
                    :variation-id="item.variation.id"
                    :is-salable="!!item.filter && item.filter.isSalable"
                    :has-children="!!item.filter && item.filter.hasActiveChildren"
                    :minimum-quantity="item.variation.minimumOrderQuantity"
                    :has-order-properties="item.hasOrderProperties"
                    :has-required-order-property="item.hasRequiredOrderProperty" 
                    :item-url="item | itemURL(urlWithVariationId)"
                    :has-price="item | hasItemDefaultPrice"
                    :item-type="item.item.itemType"
                    :one-click="true" 
                    :use-large-scale="true" 
                    :show-quantity="false">
                </add-to-basket>
                <a :href="item | itemURL" tabindex='-1'>
                    <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                        :alt="item | itemName" :title="item | itemName" :item-url="item | itemURL(urlWithVariationId)"
                        :enable-carousel="carouselEnabled" :item-id="item.item.id" :vimeo-video-id="vimeoVideoId" ref="categoryImageCarousel">
                    </category-image-carousel>
                </a>
            </div>
            <div class="productInfoContainer infos">
                <div class="tagLine">
                    <span class="tag red" :class="{'currentSale': (ourFurniture && saleBadgeVisibleMode == '1')}"
                        v-if="(item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value)"
                        v-html="this.$options.filters.numberFormat(((1 - item.prices.default.unitPrice.value / item.prices.rrp.price.value) * -100), 0, '') + ' %'">
                    </span>
                    <div class="tag currentSale" v-if="showCurrentSaleTag">
                        <span v-html="shopSaleCategoryItemText"></span>
                    </div>
                    <div class="tag" v-if="storeSpecial && storeSpecial.id == 2">
                        <span v-html="'NEU'"></span>
                    </div>
                    
                    <div class="tag quickDelivery" v-if="quickDelivery">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 56.9 25.8"
                            data-text="Sofort lieferbar!">
                            <path fill="currentColor" d="M55.4,11.9l-3.9-4.8c-.7-.8-1.6-1.3-2.7-1.3h-2.4v-3c0-1.5-1.2-2.7-2.7-2.7h-23.1c-1.5,0-2.7,1.2-2.7,2.7v17.9c0,1.5,1.2,2.7,2.7,2.7h1.5c.6,1.4,2,2.4,3.7,2.4s3-1,3.7-2.4h17.6c.6,1.4,2,2.4,3.7,2.4s3.1-1,3.7-2.4c1.4-.1,2.5-1.3,2.5-2.7v-4.7c0-1.5-.5-2.9-1.4-4.1ZM25.8,24.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM44.9,21.9h-15.2s0,0,0,0c0-2.2-1.8-4-4-4s-4,1.8-4,4,0,0,0,0h-1.2c-.7,0-1.2-.6-1.2-1.2v-3.4h25.6v4.7ZM49.5,7.4c.3.1.6.3.8.6l3.6,4.4h-3.2c-.7,0-1.2-.6-1.2-1.2v-3.7ZM50.8,24.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM55.4,20.6c0,.5-.3.9-.7,1.1,0-2.2-1.8-3.9-4-3.9s-4,1.8-4,4,0,0,0,0h-.3V7.3h1.6v3.9c0,1.5,1.2,2.7,2.7,2.7h4.1c.3.6.5,1.3.5,2.1v4.7Z"></path>
                            <path class="st0" d="M14,2.1H6c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1s-.4-1-1-1Z"></path>
                            <path class="st0" d="M10,9.1c0-.6-.4-1-1-1H1c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1Z"></path>
                            <path class="st0" d="M14,14.1H6c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1s-.4-1-1-1Z"></path>
                        </svg>
                    </div>

                    <template v-for="tag in item.tags">
                        <span :class="'ct tag tagSize' + (parseInt(tag.id) - 129)"
                            v-if="[130, 131, 132, 133].includes(tag.id)" v-html="tag.names.name"></span>
                        <span class="tag tagFavorit" v-if="tag.id == 105">Bestseller</span>
                        <span class="tag tagSet" v-if="tag.id == 153">Komplett-Set</span>
                        <span class="tag tagDiscontinued" v-if="tag.id == 14 && hasCrossPrice">Abverkauf</span>
                    </template>

                </div>

                <a :href="item | itemURL" class="productName">{{ item | itemName }}</a>

                <div class="details">
                    <div class="lengthWidthHeight" v-if="lengthWidthHeight != ''" v-html="lengthWidthHeight"></div>
                    <p class="variationHint" v-if="!item.variation.isMain" v-html="variationHint"></p>
                    <div class="itemPrice">
                        <div class="prices">
                            <div v-if="item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value"
                                class="price-view-port">
                                <del class="crossprice" v-html="'statt ' + item.prices.rrp.unitPrice.formatted"></del>
                            </div>
                            <div class="price"
                                :class="{ redPrice: (item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value) }"
                                v-html="item.prices.default.unitPrice.formatted">
                            </div>
                        </div>

                        <div class="category-unit-price small"
                            v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
                            <span v-if="item.variation.mayShowUnitPrice" v-html="item.prices.default.basePrice"></span>
                        </div>
                    </div><!--
                -->
                </div>
            </div>
        </article>
        <article class="itemCategoryProduct horizontal" v-else-if="viewMode == 'horizontal' && initialized">
            <div class="picture produkt_picture">
                <a :href="item | itemURL">
                    <lazy-img ref="itemLazyImage" picture-class="img-fluid"
                        :fallback-alt="item | itemName"
                        :title="firstImageTitle"
                        :alt="firstImageAlternativeText"
                        :image-url="item.images | itemImages(imageUrlAccessor) | itemImage">
                    </lazy-img>
                </a>
            </div>
            <div class="productInfoContainer">
                <div class="productName">
                    <a :href="item | itemURL" class="thumb-title small">{{ item | itemName }}</a>
                </div>
                <div class="itemPrice">
                    <add-to-basket :variation-id="item.variation.id"
                        :is-salable="!!item.filter && item.filter.isSalable"
                        :has-children="!!item.item && item.item.salableVariationCount > 1"
                        :interval-quantity="item.variation.intervalOrderQuantity || 1"
                        :minimum-quantity="item.variation.minimumOrderQuantity"
                        :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                        :order-properties="item.properties.filter(function (prop) { return prop.property.isOderProperty })"
                        :has-order-properties="item.hasOrderProperties"
                        :has-required-order-property="item.hasRequiredOrderProperty" :use-large-scale="false"
                        :show-quantity="false" :item-url="item | itemURL(urlWithVariationId)"
                        :has-price="item | hasItemDefaultPrice"
                        :has-graduated-price="itemGraduatedPriceisCheapestSorting || itemGraduatedPricesalableVariationCount"
                        :item-type="item.item.itemType">
                    </add-to-basket>

                    <div class="prices ml-auto">
                        <div v-if="item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value"
                            class="price-view-port">
                            <del class="crossprice" v-html="item.prices.rrp.unitPrice.formatted"></del>
                        </div>
                        <div class="price"
                            :class="{ redPrice: (item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value) }"
                            v-html="item.prices.default.unitPrice.formatted"></div>
                    </div>
                </div><!--
        -->
            </div>
        </article>
        <article class="itemCategoryProduct cartCrossSellingItem" v-if="viewMode == 'cart' && initialized">
            <div class="picture produkt_picture">
                <a :href="item | itemURL" :aria-label="'Empfehlung: Das passt dazu'" click-count>
                    <lazy-img ref="itemLazyImage" picture-class="img-fluid"
                        :fallback-alt="item | itemName"
                        :title="firstImageTitle"
                        :alt="item.images | itemImages(imageUrlAccessor) | itemImageAlternativeText"
                        :image-url="item.images | itemImages(imageUrlAccessor) | itemImage">
                    </lazy-img>
                </a>
            </div>
            <div class="itemContent">
                <div class="info">
                    <a :href="item | itemURL" class="thumb-title small" :aria-label="'Empfehlung: Das passt dazu'"
                        click-count>{{ item | itemName }}</a>
                    
                    <div v-if="item.attributes.length" class="variation">
                        <span class="attributeValue" v-for="attribute of item.attributes" v-html="attribute.value.names.name"></span>
                        <span class="variationHint" v-if="variationHint && !ourFurniture" v-html="variationHint"></span>
                    </div>

                    <span class="bundleQuantitiy" v-if="itemBundleQuantity" v-html="itemBundleQuantity + '&times;'"></span>
                    <!-- 
                    <ul v-if="texts.shortDescription" class="check compact">
                        <li v-for="(text, index) in texts.shortDescription.split('\n')" :key="index" v-html="text"></li>
                    </ul> 
                    -->
                </div>

                <div class="action">
                    <div class="prices">
                        <div v-if="item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value"
                            class="price-view-port">
                            <del class="crossprice" v-html="item.prices.rrp.unitPrice.formatted"></del>
                        </div>
                        <div class="price"
                            :class="{ redPrice: (item.prices.rrp !== null && item.prices.rrp.price.value > item.prices.default.unitPrice.value) }"
                            v-html="item.prices.default.unitPrice.formatted"></div>
                    </div>
                    <div class="basket">
                        <add-to-basket 
                            :variation-id="item.variation.id"
                            :is-salable="!!item.filter && item.filter.isSalable"
                            :has-children="!!item.filter && item.filter.hasActiveChildren"
                            :minimum-quantity="item.variation.minimumOrderQuantity"
                            :has-order-properties="item.hasOrderProperties"
                            :has-required-order-property="item.hasRequiredOrderProperty" 
                            :item-url="item | itemURL(urlWithVariationId)"
                            :has-price="item | hasItemDefaultPrice"
                            :item-type="item.item.itemType"
                            :one-click="true" 
                            :use-large-scale="true" 
                            :show-quantity="false"></add-to-basket>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import {getSlotData} from "../../helper/getSlotData";
import ApiService from "../../services/ApiService";

export default {
    components: {
        CategoryImageCarousel
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        itemBundleQuantity:
        {
            type: Number,
            default: null
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlSecondPreview"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        disableCarousel:
        {
            type: Boolean,
            default: false
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        },
        viewMode:
        {
            type: String,
            default: 'vertical'
        },
        variationId:
        {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            asyncVariation: null,
            isLoading: false,
            initialized: false
        };
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        item()
        {
            return this.itemData || this.itemSlotData || this.itemDataRef || this.asyncVariation;
        },
        shopSaleCategoryItemText()
        {
            return App.bkconfig.shopSale.currentSaleText ?? '';
        },
        carouselEnabled()
        {
            let configVal = App.config.item.enableImageCarousel;
            if(this.disableCarousel)
                return false;
            return configVal;
        },

        vimeoVideoId()
        {
            const variationProperties = this.item.variationProperties || [];

            for (const propertyGroup of variationProperties)
            {
                for (const property of propertyGroup.properties || [])
                {
                    if (property.id === 331 && property.values && property.values.value)
                    {
                        return property.values.value.trim();
                    }
                }
            }

            return "";
        },

        itemSlotData: getSlotData('item-data'),

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        basePrice()
        {
            return this.item.prices.default.basePrice;
        },

        mode()
        {
            switch(this.viewMode)
            {
                case 'vertical': return 1;
                case 'horizontal': return 2;
                case 'cart': return 3;
                default: return 1;
            }
        },

        itemPriceGraduated()
        {
           let unitPrice;
           if (App.config.item.enableGraduatedPrices) {
             unitPrice = this.item.prices.graduatedPrices.length > 0
                 ? this.item.prices.graduatedPrices[0].unitPrice
                 : this.item.prices.default.unitPrice;
           } else {
             unitPrice = this.item.prices.default.unitPrice;
           }

            return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemGraduatedPriceisCheapestSorting()
        {
            return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
        },

        itemGraduatedPricesalableVariationCount()
        {
            return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        quickDelivery()
        {
            let availabilityId = this.item.variation.availabilityId ?? 0;
            if(availabilityId !== 1)
                return false;

            return true;
        },

        inTimeForChristmas() 
        {
            var now = new Date();
            var start = new Date(now.getFullYear(), 0, 0);
            var diff = now - start;
            var oneDay = 1000 * 60 * 60 * 24;
            var currentDayOfYear = Math.floor(diff / oneDay);

            if (now.getFullYear() != 2025 || currentDayOfYear > 357) // 357 = 23.12.2025
            {
                return false;
            }
            
            // Sped
            let isSped = (this.item.variation.defaultShippingCosts > 38);
            let spedInTime = (currentDayOfYear < 351 || (currentDayOfYear == 351 && now.getHours() < 12)); // 351 = 17.12.2025
            if(isSped && !spedInTime)
                return false;

            // Package
            let packageInTime = (currentDayOfYear < 357 || (currentDayOfYear == 357 && now.getHours() < 12)); // 357 = 23.12.2025         
            if(!isSped && !packageInTime)
                return false;

            let availabilityId = this.item.variation.availabilityId ?? 0;
            if(availabilityId !== 1)
                return false;

            return true;
        },

        hasCrossPrice() {
            const hasRrpPrice = !!this.item.prices.rrp && this.item.prices.rrp !== null &&
                this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

            const hasBeforePrice = !!this.item.prices.specialOffer &&
                !!this.item.prices.default &&
                this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },
        

        ourFurniture()
        {
            return this.hasTags([63]);
        },

        isVoucher()
        {
            return  this.hasTags([175]);
        },

        showCurrentSaleTag()
        {
            const visibleMode = App.bkconfig.shopSale.categoryItemSalesBadge;
            if(visibleMode == "1" && this.ourFurniture && !this.hasCrossPrice && !this.hasTags([175, 8])) // furniture, // 175=voucher/coupon // 8 = preisbindung
                return true;
            if(visibleMode == "2" && !this.hasCrossPrice && !this.hasTags([175, 8])) // furniturew, 8 = preisbindung
                return true;
            return false;
        },
        saleBadgeVisibleMode()
        {
            return App.bkconfig.shopSale.categoryItemSalesBadge;
        },

        /**
         * @return 1 - Pine
         * @return 2 - Oak
         * @return 0 - other
         */
        woodType()
        {
            // attributeValueIds
            // 806 = corpus white, 816 = corpus gray, all others: attr #3 -> wood, not alder
            // 815 = oak
            if (!this.item.attributes) {
                return false;
            }

            // Pine
            let pineAttrValSetIds = [806, 816, 802, 803, 141, 147, 126, 110, 109, 108, 107, 90];
            if(this.item.attributes.some(attribute => pineAttrValSetIds.includes(attribute.valueId)))
            {
                return 1; 
            }

            // Oak
            let oakAttrValIds = [801, 815];
            if (this.item.attributes.some(attribute => oakAttrValIds.includes(attribute.valueId))) {
                return 2;
            }

            // Rest
            return 0;
        },

        variationHint()
        {
            if (this.item.attributes.length == 0)
                return '';

            if (this.ourFurniture && this.item.attributes.length > 0)
            {
                let text = 'In verschiedenen Varianten<br />';
                switch(this.woodType)
                {
                    case 0: text += 'aus Bio-Erlenholz'; break;
                    case 1: text += 'aus Bio-Massivholz'; break;
                    case 2: text += 'aus Bio-Eichenholz'; break;
                }
                return text;
            }
            
            if (this.item.attributes.length == 1) {

                let attributeId = this.item.attributes[0].attributeId;
                // Attr-Name: Attr-Val
                if ([7, 16, 18].includes(attributeId) && this.item.groupedAttributes !== undefined && this.item.groupedAttributes.length > 0) {
                    return this.item.groupedAttributes[0].name + ': ' + this.item.groupedAttributes[0].value;
                }

                if (attributeId == 2) {
                    return 'In verschiedenen Gr&ouml;&szlig;en';
                }

                if (attributeId == 3) {
                    return 'In verschiedenen Farben';
                }

            } 
            
            return 'In verschiedenen Varianten';
        },

        firstImageTitle()
        {
            const images = this.$options.filters.itemImages(this.item.images, this.imageUrlAccessor);

            return images[0]?.name || this.$options.filters.itemName(this.item);
        },

        firstImageAlternativeText()
        {
            const images = this.$options.filters.itemImages(this.item.images, this.imageUrlAccessor);
            return this.$options.filters.itemImageAlternativeText(images);

        },

        lengthWidthHeight() {
            if (!this.item || !this.hasTags([193])) {
                return "";
            }

            const length = Number(this.item.variation?.lengthMM);
            const width = Number(this.item.variation?.widthMM);
            const height = Number(this.item.variation?.heightMM);

            if (
                !Number.isFinite(length) || length <= 0 ||
                !Number.isFinite(width) || width <= 0 ||
                !Number.isFinite(height) || height <= 0
            ) {
                return "";
            }

            const format = valueInMm => {
                const roundedCm = Math.round((valueInMm / 10) * 2) / 2;

                return roundedCm.toLocaleString("de-DE", {
                minimumFractionDigits: 0,
                    maximumFractionDigits: 1
                });
            };

            return `<span><b>B</b> ${format(width)} cm</span> &times; <span><b>H</b> ${format(height)} cm</span> &times; <span><b>T</b> ${format(length)} cm</span>`;
        
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices
        })
    },


    methods: {
        asyncLoadVariation() {
            //
            this.isLoading = true;
            this.$store.dispatch("loadCachedVariation", this.variationId)
                .then(response => {
                    this.asyncVariation = response;
                }).catch(error => {
                    console.error("Error loading variation:", error);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.initialized = true;
                });
        },
        hasTags(tagArray) {
          if (!this.item || !Array.isArray(this.item.tags)) {
            return false;
          }
          
          return this.item.tags
            .map(tag => tag.id)
            .some(id => tagArray.includes(id));
        }



    },

    mounted() {
        this.$nextTick(() => {
            if (this.item === undefined || this.item === null) {
                this.asyncLoadVariation();
            } else {
                this.initialized = true;
            }
        });
    }
}
</script>
